import React from "react";
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * This is used to render the app root, which is allowed */
import { render } from "owa-react-dom";
import { addBottleneck, markStart, markEnd, getPltPromise } from "owa-performance";
import { setScriptsLoadedAtPlt } from "owa-shared-post-boot/lib/scriptsLoadedAtPlt";
import { removeLoadingScreen } from "./removeLoadingScreen";
import type { LoaderOptions } from "./types/LoaderOptions";

import { timeout } from "owa-sleep/lib/timeout";
const PLT_PROMISE_TIMEOUT = 1500;

export default function asyncRender(node: React.JSX.Element, getContainer: () => HTMLElement, loaderOptions?: LoaderOptions): Promise<void> {
    return new Promise<void>(function (resolve: () => void, reject: (reason: any) => void) {
        const shouldDelayPlt = loaderOptions?.delayRender;
        
        function completeBoot() {
            if (shouldDelayPlt) {
                try {
                    // mark end for timeout
                    markEnd("postren");
                }
                catch {
                    // might be completed already
                }
            }
            removeLoadingScreen(loaderOptions);
            setTimeout(resolve);
        }
        function onMount() {
            setScriptsLoadedAtPlt();
            
            if (shouldDelayPlt) {
                timeout(getPltPromise(), PLT_PROMISE_TIMEOUT, new Error("PLT promise timed out")).then(completeBoot, completeBoot);
            }
            else {
                completeBoot();
            }
        }
        function Component() {
            React.useEffect(onMount, []);
            return node;
        }
        
        const asyncRenderInternal = (bottleneck: string) => {
            addBottleneck("DR", bottleneck);
            
            try {
                markStart("ren");
                render(<Component />, getContainer(), () => markEnd("ren"));
            }
            catch (error) {
                reject(error);
            }
        };
        
        if (window.document.readyState != "loading") {
            // Render on a separate task
            setTimeout(() => asyncRenderInternal("R"), 0);
        }
        else if (window.document.addEventListener as any) {
            addDomLoadedEvent(asyncRenderInternal);
        }
        else {
            window.onload = () => asyncRenderInternal("OL");
        }
    });
}

const domLoadedEvent = "DOMContentLoaded";
function addDomLoadedEvent(asyncRenderInternal: (bottleneck: string) => void) {
    function domLoaded() {
        window.document.removeEventListener(domLoadedEvent, domLoaded);
        asyncRenderInternal("EL");
    }
    window.document.addEventListener(domLoadedEvent, domLoaded, false);
}
